export const LOGO_UPLOAD_FILE_CHECKLIST = [
  'Max file size: 500 kb',
  'File type: png/Jpeg',
];

export const COLOR_TYPES = [
  {
    key: 'headerColor',
    headerText: 'Header Colour',
    infoText: 'This determines the colour of the header element.',
  },
  {
    key: 'primaryColor',
    headerText: 'Primary Brand Colour',
    infoText:
      'This determines the colour of the buttons, link, and interactive elements.',
  },
  {
    key: 'textColor',
    headerText: 'Text Colour',
    infoText:
      'This determines the colour of the text displayed over the primary colour.',
  },
];
